import type { ShipmentState } from '../../api/types';
import type { Tone } from '../../ui';

/** One tone per payable state, defined once for both portals. */
export { PAYABLE_TONE as PAYMENT_TONE } from '../despatch-payable';

/** The existing shipment states, toned. No state is added here: the label comes from `shipmentStateLabel`. */
export const SHIPMENT_TONE: Record<ShipmentState, Tone> = {
  DRAFT: 'lapse', CONFIRMED: 'lapse', PACKED: 'us', AWAITING_PAYMENT: 'run',
  DISPATCHED: 'run', DELIVERED: 'done', CANCELLED: 'stop',
};
